module.exports = __webpack_public_path__ + "img/CI Now+UTH.2ac98600.png";